import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchColors, deleteColor} from '../../redux/actions/color/colorAction';
import DataTable from 'react-data-table-component';
import { Box, IconButton, TextField, Typography, Button } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import { confirmDelete, showSuccess } from '../../utils/alertUtils'; 
import { toast } from 'react-toastify';

const ColorTable = ({ onEdit }) => {
  const dispatch = useDispatch();
  const colors = useSelector((state) => state.color.colors);
  const { user } = useSelector((state) => state.login);
  const [filterText, setFilterText] = useState('');

  useEffect(() => {
    dispatch(fetchColors());
  }, [dispatch]);

  const handleDelete = async (id) => {
    const result = await confirmDelete('Are you sure?', 'This color will delete permanently!');
    if (result.isConfirmed) {
      try {
        await dispatch(deleteColor(id));
        showSuccess('Deleted!', 'The color has been deleted.');
      } catch (error) {
        const errorMessage = error?.response?.data?.message || error?.message || 'Failed to delete color';
        toast.error(errorMessage);
      }
    }
  };

  const handleNew = () => {
    onEdit(null);
  };

  const filteredColors = colors.filter((color) =>
    color.name.toLowerCase().includes(filterText.toLowerCase())
  );

  const columns = [
    {
      name: <Typography fontWeight="bold">Name</Typography>,
      selector: (row) => row.name,
      sortable: true,
    },
    ...(user?.role === 'Admin' ? [{
      name: <Typography fontWeight="bold">Actions</Typography>,
      cell: (row) => (
        <Box sx={{ display: 'flex', gap: 1 }}>
          <IconButton size="small" onClick={() => onEdit(row)}>
            <EditIcon fontSize="small" sx={{ color: '#2196f3' }}/>
          </IconButton>
          <IconButton size="small" onClick={() => handleDelete(row.id)}>
            <DeleteIcon fontSize="small" sx={{ color: '#f44336' }}/>
          </IconButton>
        </Box>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    }] : []),
  ];

  return (
    <Box>
      {/* Header Row with Title & Search */}
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          mb: 2,
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <Typography variant="h6" sx={{ fontWeight: 'bold', color: 'primary.main' }}>
            Color
          </Typography>
          {user?.role === 'Admin' && (
            <Button
              variant="contained"
              color="primary"
              startIcon={<AddIcon />}
              onClick={handleNew}
              sx={{
                textTransform: 'none',
                boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                '&:hover': {
                  boxShadow: '0 4px 8px rgba(0,0,0,0.2)',
                },
              }}
            >
              New
            </Button>
          )}
        </Box>

        <TextField
          size="small"
          placeholder="Search name..."
          value={filterText}
          onChange={(e) => setFilterText(e.target.value)}
          sx={{
            width: '250px',
            '& .MuiInputBase-root': {
              backgroundColor: 'transparent',
            },
          }}
        />
      </Box>

      {/* Table */}
      <Box sx={{ height: '400px', overflowY: 'auto' }}>
        <DataTable
          columns={columns}
          data={filteredColors}
          pagination
          highlightOnHover
          dense
          responsive
          noHeader
        />
      </Box>
    </Box>
  );
};

export default ColorTable;
